import { render, staticRenderFns } from "./PaymentsDeposits.vue?vue&type=template&id=2bf4cbba&scoped=true&"
import script from "./PaymentsDeposits.vue?vue&type=script&lang=ts&"
export * from "./PaymentsDeposits.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentsDeposits.vue?vue&type=style&index=0&id=2bf4cbba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf4cbba",
  null
  
)

export default component.exports